import { EstateStatusKey } from '@/modules/estate/constants/EstateStatusKey';

export class EstateWorkTimeEntryMeta {
  status?: EstateStatusKey;

  constructor(model: Partial<EstateWorkTimeEntryMeta> = {}) {
    this.status = model.status;
  }
}
